export const getHeader = () =>
  document.querySelectorAll('[role="banner"]')?.[0];
